import { Link } from "react-router-dom/dist"

const Breadcrumb = ({ link }) => {
    return (
        <Link to={link} className="flex items-center mb-8 text-white w-fit">
            <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.187825 3.14583L3.20866 0.125C3.25033 0.0833333 3.29546 0.0520833 3.34408 0.03125C3.39269 0.0104166 3.44477 -2.06415e-08 3.50033 -1.82131e-08C3.61144 -1.33563e-08 3.70866 0.0381944 3.79199 0.114583C3.87533 0.190972 3.91699 0.291667 3.91699 0.416667L3.91699 6.75C3.91699 6.875 3.87533 6.97569 3.79199 7.05208C3.70866 7.12847 3.61144 7.16667 3.50033 7.16667C3.47255 7.16667 3.37533 7.125 3.20866 7.04167L0.187825 4.02083C0.11838 3.95139 0.0697692 3.88194 0.0419913 3.8125C0.0142136 3.74306 0.000325043 3.66667 0.000325046 3.58333C0.00032505 3.5 0.0142137 3.42361 0.0419913 3.35417C0.0697692 3.28472 0.11838 3.21528 0.187825 3.14583Z" fill="#1AB6F9" />
            </svg>

            <span className="ml-2">Go Back</span>
        </Link>
    )
}

export default Breadcrumb